// src/mocks/data/operations.demo.js
// Demo day: Tue Jan 13 2026 — caja opened 08:00, snapshot at 13:30
// Net movements: -68k +280k -280k -100k -500k = -668k (matches production screen structure)

export const currentOperation = {
    operationId: 81,
    operation_date: '2026-01-13',
    status: 'open',
    openedBy: 5,
    openedAt: '2026-01-13T08:00:16.213333',
    initialCash: 900000.0,
    created_at: '2026-01-13T08:00:16.213333',
    updated_at: '2026-01-13T13:30:00.000000',
};

export const currentMovements = [
    { movement_id: 285, operation_id: 81, movement_timestamp: '2026-01-13T08:06:00.000000', movementType: 'withdrawal', amount: 68000.0,  reason: 'supplier_payment', description: 'ESPERANZA',                                                               authorized_by: null, created_by: 3 },
    { movement_id: 286, operation_id: 81, movement_timestamp: '2026-01-13T09:02:00.000000', movementType: 'income',     amount: 280000.0, reason: 'other',            description: 'PAGO CUENTA ABIERTA - RA-PAGO-20260113-000243 - LUCAS CARPINTERO', authorized_by: null, created_by: 3 },
    { movement_id: 287, operation_id: 81, movement_timestamp: '2026-01-13T09:08:00.000000', movementType: 'withdrawal', amount: 280000.0, reason: 'security',          description: 'PROSEGUR ARGENTINA S.A.',                                          authorized_by: null, created_by: 3 },
    { movement_id: 288, operation_id: 81, movement_timestamp: '2026-01-13T09:40:00.000000', movementType: 'withdrawal', amount: 100000.0, reason: 'other',             description: 'RETIRO',                                                           authorized_by: null, created_by: 3 },
    { movement_id: 289, operation_id: 81, movement_timestamp: '2026-01-13T10:14:00.000000', movementType: 'withdrawal', amount: 500000.0, reason: 'bank_deposit',      description: 'BANCO NACIÓN',                                                     authorized_by: null, created_by: 3 },
];

export const closingSummary = {
    // Partial-day snapshot (13:30) — cash sales only count invoices up to now
    // initialCash + cashSales + income - withdrawals = expectedCash
    // 900,000 + 498,581.41 + 280,000 - 948,000 = 730,581.41
    initialCash:  900000.00,
    cashSales:    498581.41,
    income:       280000.00,   // manual income: AR payment Lucas Carpintero
    withdrawals:  948000.00,   // 68k + 280k + 100k + 500k
    expenses:     0,
    expectedCash: 730581.41,
};

export const operationReport = {
    operation_id: 80,
    operation_date: '2026-01-31',
    status: 'closed',
    opened_by: 5,
    opened_at: '2026-01-31T11:01:16.213333',
    initial_cash: 70000.0,
    expected_cash: 185251.94,
    counted_cash: 270000.0,
    variance: 84748.06,
    closed_by: 5,
    closed_at: '2026-01-31T16:34:27.126666',
};

// Shaped to match what ReportesTab reads: res.data.operations / .pagination / .summary
// All fields camelCase to match table column dataIndex values
// Surplus total: 56765.82+1257.45+75916.56+3695.38+46198.65+419.10+0.45 = 184,253.41
// Shortage total: 23216.80+24547.20 = 47,764.00  — Net: 136,489.41
export const operationList = {
    operations: [
        { operationId: 80, operationDate: '2026-01-12T00:00:00.000Z', status: 'closed', openedBy: 5, openedAt: '2026-01-12T11:52:00.000Z', initialCash: 150000.0,  expectedCash:  908234.18, countedCash:  965000.0,  variance:  56765.82, closedBy: 5, closedAt: '2026-01-12T22:45:00.000Z' },
        { operationId: 79, operationDate: '2026-01-10T00:00:00.000Z', status: 'closed', openedBy: 3, openedAt: '2026-01-10T12:03:00.000Z', initialCash: 320000.0,  expectedCash:  638742.55, countedCash:  640000.0,  variance:   1257.45, closedBy: 5, closedAt: '2026-01-10T22:30:00.000Z' },
        { operationId: 78, operationDate: '2026-01-09T00:00:00.000Z', status: 'closed', openedBy: 5, openedAt: '2026-01-09T11:58:00.000Z', initialCash: 180000.0,  expectedCash:  744216.80, countedCash:  721000.0,  variance: -23216.80, closedBy: 5, closedAt: '2026-01-09T22:22:00.000Z' },
        { operationId: 77, operationDate: '2026-01-08T00:00:00.000Z', status: 'closed', openedBy: 3, openedAt: '2026-01-08T12:10:00.000Z', initialCash: 450000.0,  expectedCash: 1104083.44, countedCash: 1180000.0,  variance:  75916.56, closedBy: 3, closedAt: '2026-01-08T22:48:00.000Z' },
        { operationId: 76, operationDate: '2026-01-07T00:00:00.000Z', status: 'closed', openedBy: 5, openedAt: '2026-01-07T11:45:00.000Z', initialCash: 200000.0,  expectedCash: 1389547.20, countedCash: 1365000.0,  variance: -24547.20, closedBy: 5, closedAt: '2026-01-07T22:35:00.000Z' },
        { operationId: 75, operationDate: '2026-01-06T00:00:00.000Z', status: 'closed', openedBy: 3, openedAt: '2026-01-06T12:05:00.000Z', initialCash: 380000.0,  expectedCash:  876304.62, countedCash:  880000.0,  variance:   3695.38, closedBy: 5, closedAt: '2026-01-06T22:52:00.000Z' },
        { operationId: 74, operationDate: '2026-01-05T00:00:00.000Z', status: 'closed', openedBy: 5, openedAt: '2026-01-05T11:56:00.000Z', initialCash: 290000.0,  expectedCash:  953801.35, countedCash: 1000000.0,  variance:  46198.65, closedBy: 5, closedAt: '2026-01-05T22:28:00.000Z' },
        { operationId: 73, operationDate: '2026-01-03T00:00:00.000Z', status: 'closed', openedBy: 3, openedAt: '2026-01-03T13:02:00.000Z', initialCash: 100000.0,  expectedCash:  234580.90, countedCash:  235000.0,  variance:    419.10, closedBy: 3, closedAt: '2026-01-03T18:48:00.000Z' },
        { operationId: 72, operationDate: '2026-01-02T00:00:00.000Z', status: 'closed', openedBy: 5, openedAt: '2026-01-02T11:50:00.000Z', initialCash: 160000.0,  expectedCash:  712490.55, countedCash:  712491.0,  variance:      0.45, closedBy: 5, closedAt: '2026-01-02T22:40:00.000Z' },
    ],
    pagination: { page: 1, limit: 20, total: 9 },
    summary: {
        byWeek: [],
        byMonth: [],
        overall: {
            totalClosedOperations: 9,
            totalOperations: 10,
            totalSurplus: 184253.41,
            totalShortage: 47764.00,
            totalNet: 136489.41,
        },
    },
};
